import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import LanguageSwitcher from './LanguageSwitcher';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const guestLinks = [{ to: '/courses', label: t('nav.allCourses') }];

  const learnerLinks = [
    { to: '/courses', label: t('nav.allCourses') },
    { to: '/my-courses', label: t('nav.myCourses') },
    { to: '/', label: t('nav.dashboard') },
    { to: '/certificates', label: t('nav.certificates') },
    { to: '/badges', label: t('nav.badges') },
    { to: '/leaderboard', label: t('nav.leaderboard') },
    { to: '/achievements', label: t('nav.achievements') },
    { to: '/goals', label: t('nav.goals') },
  ];

  const instructorLinks = [
    { to: '/my-courses', label: t('nav.myCourses') },
    { to: '/create-course', label: t('nav.createCourse') },
    { to: '/instructor', label: t('nav.instructorConsole') },
  ];

  const adminLinks = [
    { to: '/admin', label: t('nav.adminDashboard') },
    { to: '/analytics', label: t('nav.analytics') },
    { to: '/create-course', label: t('nav.manageCourses') },
    { to: '/instructor', label: t('nav.instructorConsole') },
    { to: '/students', label: t('nav.students') },
    { to: '/certificates', label: t('nav.manageCertificates') },
  ];

  const getNavLinks = () => {
    if (!user) return guestLinks;
    if (user.role === 'admin') return adminLinks;
    if (user.role === 'instructor') return instructorLinks;
    return learnerLinks;
  };

  const navLinks = getNavLinks();

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img
            src="https://anu-kingdom.techbrio.io/wp-content/uploads/2025/10/image-19.png"
            alt="Logo"
            style={{ width: "100px" }}
          />
        </Link>
        <ul className="nav-menu">
          {navLinks.map((link) => (
            <li key={link.to}>
              <Link to={link.to}>{link.label}</Link>
            </li>
          ))}
          {user ? (
            <>
              <li className="nav-dropdown">
                <span className="user-info dropdown-trigger">
                  {user.first_name} ({user.role})
                </span>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/profile">{t('nav.profile')}</Link>
                  </li>
                  <li>
                    <Link to="/settings">{t('nav.settings')}</Link>
                  </li>
                  <li>
                    <button onClick={handleLogout} className="btn-logout">
                      {t('nav.logout')}
                    </button>
                  </li>
                </ul>
              </li>
            </>
          ) : (
            <>
              <li>
                <Link to="/login">{t('nav.login')}</Link>
              </li>
              <li>
                <Link to="/register">{t('nav.register')}</Link>
              </li>
            </>
          )}
          <li><LanguageSwitcher /></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
